window.__INITIAL_STATE__ = {
  app: {
    isMicrophoneRecommended: true,
    isCameraRecommended: false,
    isLocationRecommended: true,
    isHmtDevice: false,
    roles: {
      assistant: [
        'muteParticipants',
        'exchangeRole',
        'showInfo'
      ]
    },
    idealConstraints: {
      microphone: {
        noiseSuppression: true,
        echoCancellation: true,
        sampleRate: 48000,
      }
    }
  }
}
